// Coercion applied to a record on its way out of Salesforce and into the form.
//
// Two load paths populate the same controls - created() for the ?sfid= deep
// link and populateRenewalForm for the search results - so the rules live here
// rather than being written twice and drifting, which is exactly how the deep
// link ended up without the phone normalization the renewal path had.
//
// Every rule here fixes the same shape of bug: Salesforce holds a value the
// control cannot represent, so the screen shows something other than what is
// bound. None of them invent data - an unrecognized value is passed through
// untouched.
import { canonicalCountry } from "./options";
import { normalizePhone } from "./contactValidation";
import { toStateCode, toHomePortState } from "@/config/usStates";

// Billing and shipping states bind to a select of two-letter codes, and the
// zip autofill returns one. 1,719 accounts hold something else - "Florida",
// "Fl", "fl" - which matched no option, so the box showed its placeholder
// while the record had a state all along.
export function coerceAccountField(name, value) {
  if (name.endsWith("country")) return canonicalCountry(value);
  if (name.endsWith("state")) return toStateCode(value);
  return value;
}

// Home_Port_State__c is the opposite: a restricted picklist of full names.
// Sending "MS" instead of "Mississippi" is not a display problem, it is the
// rejection that leaves the boat stranded in Postgres.
export function coerceBoatField(name, value) {
  if (name === "home_port_state__c") return toHomePortState(value);
  return value;
}

// Salesforce holds 8,774 numbers written as "+1(716) 481-4292". Stripping only
// the punctuation leaves eleven digits, which fails the form's maxLength(10).
export function coerceContactField(name, value) {
  if (name.includes("phone") && value != null) return normalizePhone(value);
  return value;
}
